import {builderFieldsType} from '../CreateBuilder/builderFields';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const BUILDER_SUBTYPE_TO_SERVER = {
  PRODUCT_BASED: 'Product based',
  ACTION_BASED: 'Action based',
  INSTRUCTION: 'Service', // Curo changed from 'Execution Only'
};

export const BUILDER_TYPES = {
  Recommendation: 'Recommendation',
  Instruction: 'Instruction',
} as const;

export type BuilderTypeValue = typeof BUILDER_TYPES[keyof typeof BUILDER_TYPES];

export const SPP_BUILDER_TYPES = {
  ExecutionOnly: 'Execution Only',
  Advised: 'Advised',
} as const;

export type SppBuilderTypeValue =
  typeof SPP_BUILDER_TYPES[keyof typeof SPP_BUILDER_TYPES];

export const serverToBuilderTypeLabel = (val?: null | string) => {
  if (val === BUILDER_SUBTYPE_TO_SERVER.ACTION_BASED) {
    return BUILDER_TYPES.Recommendation;
  }
  if (val === BUILDER_SUBTYPE_TO_SERVER.PRODUCT_BASED) {
    return BUILDER_TYPES.Recommendation;
  }
  if (val === BUILDER_SUBTYPE_TO_SERVER.INSTRUCTION) {
    return BUILDER_TYPES.Instruction;
  }
};

export const builderFormToServerType = (values: builderFieldsType) => {
  if (values.planAction === OVRecommendActionEnum.ACTION) {
    return BUILDER_SUBTYPE_TO_SERVER.ACTION_BASED;
  }
  return BUILDER_SUBTYPE_TO_SERVER.PRODUCT_BASED;
};
